module.exports = __webpack_public_path__ + "img/small.dc2d0e0b.jpg";